var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 33,
    viewBox: "0 0 45 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0859 32.6631H11.0859C8.0526 32.6631 5.46094 31.6131 3.31094 29.5131C1.16094 27.4131 0.0859375 24.8464 0.0859375 21.8131C0.0859375 19.2131 0.869271 16.8964 2.43594 14.8631C4.0026 12.8298 6.0526 11.5298 8.58594 10.9631C9.41927 7.89642 11.0859 5.41309 13.5859 3.51309C16.0859 1.61309 18.9193 0.663086 22.0859 0.663086C25.9859 0.663086 29.2943 2.02142 32.0109 4.73809C34.7276 7.45475 36.0859 10.7631 36.0859 14.6631C38.3859 14.9298 40.2943 15.9214 41.8109 17.6381C43.3276 19.3548 44.0859 21.3631 44.0859 23.6631C44.0859 26.1631 43.2109 28.2881 41.4609 30.0381C39.7109 31.7881 37.5859 32.6631 35.0859 32.6631H24.0859V18.3631L27.2859 21.4631L30.0859 18.6631L22.0859 10.6631L14.0859 18.6631L16.8859 21.4631L20.0859 18.3631V32.6631Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.1a9ec72d.svg";
export { ForwardRef as ReactComponent };